import { defineComponent as I, useAttrs as V, computed as n, ref as E, openBlock as s, createBlock as u, unref as i, mergeProps as h, withCtx as v, createVNode as f, toHandlers as S, createElementBlock as l, Fragment as k, normalizeClass as a, renderSlot as r, createCommentVNode as o, createElementVNode as b } from "vue";
import { RevButtonBase as z } from "@ds/components/ButtonBase";
import { RevListItemBase as F } from "@ds/components/ListItemBase";
import { RevSkeleton as C } from "@ds/components/Skeleton";
import { useTrackedListeners as H } from "../../composables/useTrackedListeners.js";
import P from "../../icons/generated/IconChevronRight.vue2.js";
import { omit as T } from "../../utils/omit.js";
import { tw as d } from "../../utils/tailwind.js";
const W = /* @__PURE__ */ I({
  name: "RevListItemAction",
  inheritAttrs: !1,
  __name: "ListItemAction",
  props: {
    to: {},
    wrapperAttrs: {},
    itemsCenter: { type: Boolean, default: !1 },
    hasChevron: { type: Boolean, default: !1 },
    isLoading: { type: Boolean, default: !1 },
    isDisabled: { type: Boolean, default: !1 }
  },
  setup(e, { expose: y }) {
    const { listeners: g } = H({
      to: e.to,
      wrapperAttrs: e.wrapperAttrs,
      itemsCenter: e.itemsCenter,
      hasChevron: e.hasChevron
    }), A = V(), m = n(() => T(A, ["onClick"])), c = E(null);
    function $() {
      const t = c.value;
      Array.isArray(t) || t === null || t.$el && t.$el.focus();
    }
    y({ focus: $ });
    const B = n(
      () => e.to || m.value?.href
    ), L = n(() => [
      d`shrink-0 self-center`,
      e.isDisabled ? d`text-action-default-hi-disabled` : d`text-action-default-hi`
    ]);
    return (t, j) => (s(), u(i(F), h(e.wrapperAttrs, {
      "is-disabled": e.isDisabled && !e.isLoading,
      "items-center": e.itemsCenter
    }), {
      default: v(({
        wrapperClassNames: w,
        prefixClassNames: p,
        descriptionClassNames: D,
        labelClassNames: R,
        suffixClassNames: x,
        mainAreaClassNames: N
      }) => [
        f(i(z), h(m.value, {
          ref_key: "item",
          ref: c,
          class: ["focus-visible-outline-inset-hi rounded-inherit px-24", [
            w,
            e.isLoading || e.isDisabled ? "cursor-default" : "hover:bg-static-default-min-hover"
          ]],
          disabled: e.isLoading || e.isDisabled,
          to: e.isDisabled ? void 0 : B.value
        }, S(i(g))), {
          default: v(() => [
            e.isLoading ? (s(), l(k, { key: 0 }, [
              f(i(C), {
                class: "mr-16 grow",
                height: "1.5rem",
                shape: "line"
              }),
              f(i(C), {
                class: "w-48 shrink-0",
                height: "1.5rem",
                shape: "line"
              })
            ], 64)) : (s(), l(k, { key: 1 }, [
              t.$slots.prefix ? (s(), l("div", {
                key: 0,
                class: a(p)
              }, [
                r(t.$slots, "prefix")
              ], 2)) : o("", !0),
              b("div", {
                class: a(N)
              }, [
                b("span", {
                  class: a(R)
                }, [
                  r(t.$slots, "label")
                ], 2),
                t.$slots.description ? (s(), l("span", {
                  key: 0,
                  class: a(D)
                }, [
                  r(t.$slots, "description")
                ], 2)) : o("", !0)
              ], 2),
              t.$slots.suffix ? (s(), l("div", {
                key: 1,
                class: a(["self-center", x])
              }, [
                r(t.$slots, "suffix")
              ], 2)) : o("", !0),
              e.hasChevron ? (s(), u(i(P), {
                key: 2,
                class: a([L.value, t.$slots.suffix && "ml-4"])
              }, null, 8, ["class"])) : o("", !0)
            ], 64))
          ]),
          _: 2
        }, 1040, ["class", "disabled", "to"])
      ]),
      _: 3
    }, 16, ["is-disabled", "items-center"]));
  }
});
export {
  W as default
};
